// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__RJ5lv","addWidgetButton":"Header_addWidgetButton__1HRld","dashboardTabs":"Header_dashboardTabs__29_wi","active":"Header_active__UJqcJ"};